










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import { VideoStatistic } from '@/connectors/bundles/video-statistic.model';
import MpShowNumberCard from '@/components/controls/mp-card/MpShowNumberCard.vue';
import MpShowRatingCard from '@/components/controls/mp-card/MpShowRatingCard.vue';
import MpShowRatingCountsCard from '@/components/controls/mp-card/MpShowRatingCountsCard.vue';
import MpModalVideoPlayer from '@/components/wrappers/mp-modal-video-player/MpModalVideoPlayer.vue';
import { Bundle } from '@/connectors/bundles/bundle.model';
@Component({
  components: { MpModalVideoPlayer, MpShowRatingCountsCard, MpShowRatingCard, MpShowNumberCard, MpCard }
})
export default class MpVideoStatistic extends Vue {
  @Prop({ required: true })
  videoStatistic!: VideoStatistic;

  @Prop({ required: true })
  bundle!: Bundle;

  @Prop({ required: true })
  fixedCardHeight!: number;

  showVideoDialog: boolean = false;

  async playVideo() {
    if (!this.videoStatistic || !this.videoStatistic.url) {
      return;
    }

    this.showVideoDialog = true;
  }
}
